
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cms/[cms_url]",
      function () {
        return require("private-next-pages/cms/[cms_url].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cms/[cms_url]"])
      });
    }
  